module.exports = __webpack_public_path__ + "media/dobry_wzor/mail-polub-nas-bcg@2x-e035bb5f.png";